require('./transfersAgendaTableRow.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKIconTask } = require('commonsComponents/OKIconTask');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');

// @ components
const { TransfersAgendaMoreInfoRow } = require('components/transfers/transfersAgenda/transfersAgendaMoreInfoRow/transfersAgendaMoreInfoRow');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { formatCurrency } = require('utilities/currencyHelper');

class TransfersAgendaTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleClick(activateLink) {
        this.props.history.push(activateLink);
    }

    buildTableRow() {
        const { immBeneficiary, isExpanded, onRowClick, immScreen } = this.props;
        const account = getLastNChars( immBeneficiary.get('iban') || immBeneficiary.get('accountNumber') );
        // const descriptionClasses = classNames('transfers-agenda-table-row__description', { 'transfers-agenda-table-row__description--selected': isExpanded });
        const activateLink = `/myprofile/transfers/transfer/beneficiary/${immBeneficiary.get('id')}`;

        let tableRow;
        if (immScreen.get('isMobile')) {
            tableRow = (
                <React.Fragment>
                    <OKTableRow isExpanded={isExpanded}>
                        <OKTableCell className="transfers-agenda-table-row__expand-column">
                            <OKCollapsingToggler handlerToggle={onRowClick} isExpanded={isExpanded} isIconSecondary={true}/>
                        </OKTableCell>
                        <OKTableCell className="transfers-agenda-table-row__alias-column">
                            <p className="transfers-agenda-table-row__alias-name">{immBeneficiary.get('alias')}</p>
                            <p>{account}</p>
                        </OKTableCell>
                        <OKTableCell className="transfers-agenda-table-row__transfer-column">
                            { !isExpanded && <OKIconTask
                                icon="icon-transferir"
                                onClick={() => this.handleClick(activateLink)}
                                style="default-alternative"
                            /> }
                        </OKTableCell>
                    </OKTableRow>
                    { isExpanded && <OKTableRow isExpanded={isExpanded}>
                        <OKTableCell />
                        <OKTableCell colSpan={2}>
                            <OKButton
                                leftIcon="icon-transferir"
                                modifier="secondary"
                                to={activateLink}
                            >
                                <FormattedText value="transfersAgenda-transferButtonLabel" />
                            </OKButton>
                        </OKTableCell>
                    </OKTableRow> }
                </React.Fragment>
            );
        } else {
            const { immBeneficiary, isExpanded, onRowClick } = this.props;
            const account = getLastNChars( immBeneficiary.get('iban') || immBeneficiary.get('accountNumber') );
            const descriptionClasses = classNames('transfers-agenda-table-row__description', { 'transfers-agenda-table-row__description--selected': isExpanded });
            const activateLink = `/myprofile/transfers/transfer/beneficiary/${immBeneficiary.get( 'id' )}`;

            tableRow = (
                <OKTableRow isExpanded={isExpanded}>
                    <OKTableCell className="transfers-agenda-table-row__expand-column">
                        <OKCollapsingToggler handlerToggle={onRowClick} isExpanded={isExpanded} isIconSecondary={!__CONTACT_CENTER__} />
                    </OKTableCell>
                    <OKTableCell className="transfers-agenda-table-row__alias-column">
                        <p className={descriptionClasses}>
                            {immBeneficiary.get('alias')}
                        </p>
                    </OKTableCell>
                    <OKTableCell className="transfers-agenda-table-row__account-column">
                        {account}
                    </OKTableCell>
                    <OKTableCell className="transfers-agenda-table-row__currency-column">
                        {formatCurrency(immBeneficiary.get('currency'))}
                    </OKTableCell>
                    <OKTableCell className="transfers-agenda-table-row__country-column">
                        {immBeneficiary.get('country')}
                    </OKTableCell>
                    <OKTableCell className="transfers-agenda-table-row__transfer-column">
                        <OKButton
                            modifier="secondary"
                            size="small"
                            to={activateLink}
                        >
                            <FormattedText value="transfersAgenda-transferButtonLabel" />
                        </OKButton>
                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }


    render() {
        const { immBeneficiary, immScreen, isExpanded } = this.props;
        const tableRow = this.buildTableRow();
        return (
            <tbody>
                {tableRow}
                {
                    isExpanded &&
                    <TransfersAgendaMoreInfoRow
                        immBeneficiary={immBeneficiary}
                        immScreen={immScreen}
                    />
                }
            </tbody>
        );
    }
}

TransfersAgendaTableRow.propTypes = {
    history: PropTypes.object.isRequired,
    immBeneficiary: PropTypes.object,
    immScreen: PropTypes.object,
    isExpanded: PropTypes.bool,
    onRowClick: PropTypes.func,
};

module.exports = withRouter(TransfersAgendaTableRow);
